// Session-level unlock for the "verify OTP to view transaction details" gate.
// Verifying once unlocks viewing ANY transaction's details for a fixed 10-minute window
// from the moment of verification (no extension on activity -- a new OTP is required
// once that window elapses, even if the admin stayed continuously active). Leaving the
// Transactions module for any other module clears the unlock immediately, so returning
// always requires a fresh OTP.

const STORAGE_KEY = "transactionViewUnlockedUntil";
export const TRANSACTION_VIEW_UNLOCK_WINDOW_MS = 10 * 60 * 1000;

export function isTransactionViewUnlocked(): boolean {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  const unlockedUntil = Number(raw);
  return !Number.isNaN(unlockedUntil) && Date.now() < unlockedUntil;
}

export function markTransactionViewUnlocked(windowMs: number = TRANSACTION_VIEW_UNLOCK_WINDOW_MS): void {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now() + windowMs));
}

export function clearTransactionViewUnlock(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
